export default /* css */ `
:host {
	--oc-font-family: Roboto, sans-serif;
	
	--gazzetta-black: #000;
	--gazzetta-orange: #e27e3a;
	--gazzetta-pink: #ebccce;
	--gazzetta-white: #FFF;
	
	--oc-bg-grey-light: var(--gazzetta-white);
	--oc-border: var(--gazzetta-black);
	--oc-line-secondary: var(--gazzetta-black);
	--oc-primary-white: var(--gazzetta-white);
	--oc-text-body: var(--gazzetta-black);
	--oc-text-subtext: var(--gazzetta-black);

	--ogm-pelicans: var(--gazzetta-black);
	--ogm-title-color-1: var(--gazzetta-orange);
	--ogm-white: var(--gazzetta-pink);
	
  --ogm-active-tab-bg-color: var(--gazzetta-orange);
  --ogm-active-tab-color: var(--gazzetta-white);

	--ogm-grid-best-odds-primary-color: var(--gazzetta-orange); 
  --ogm-grid-best-odds-secondary-color: var(--gazzetta-orange);
  --ogm-grid-best-odds-text-color: var(--gazzetta-white);
	
  --ogm-grid-compare-bg-color: #e27e3a90;
	--ogm-grid-compare-color: var(--gazzetta-black);
	
  --ogm-grid-see-all-color: var(--gazzetta-orange);
	
  --ogm-grid-selected-cell-bg-color: var(--gazzetta-orange);
}`;
